<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction. Lowdown on the Colonial Town</a></p>
<p class="toc1"><a href="#/chapter01">Ghost of a Spook: Grudge Lingers in the Afterlife</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Legend of the Female Stranger: Who Is Buried in this Anonymous Grave?</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Fatal and Melancholy Affair: Young Lovers Meet a Tragic Fate</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Three Falling Ghosts: Phantom Hotel Haunts the Carlyle House</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">War of the Rose Gardens: Disagreement Lingers on Franklin Street</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Lost Cause: James W. Jackson and the War of Northern Aggression</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Ghosts of Red Hill: Cloaked Woman Haunts Braddock Heights</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">House of Cards: Childish Ghosts Are Blowing in the Wind</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">The Haunted Mansion: Woodlawn Is the Most Haunted Home in Virginia</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Bat in the Belfry: Alexandria’s Town Square Sees All the Action</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?dd8a4d76